import $ from 'jquery';

import '../../css/extra-info-generator.css';

class ExtraInfoGenerator {
	constructor(selector, elementHtml) {
		this.selector = selector;
		this.elementHtml = elementHtml;
	}

	static convertMessage(message) {
		if (typeof(message) !== 'string') {
			message = String(message);
		}

		return message.replace(/\n/g, '<br>');
	}

	generate(message, duration) {
		let container = $(this.selector);

		let element = $(this.elementHtml).html(message);
		container.append(element);

		setTimeout(() => {
			element.addClass('show_message');
		}, 50);

		setTimeout(() => {
			element.addClass('hide_message');
			element.removeClass('show_message');
		}, duration);

		setTimeout(() => {
			element.remove();
		}, duration + 1000);
	}
}

class ToastManager extends ExtraInfoGenerator {
	constructor() {
		super('.toast-container', '<div class="toast"></div>');
	}

	generate(message, duration) {
		super.generate(ExtraInfoGenerator.convertMessage(message), duration);
	}
}

class SnackbarManager extends ExtraInfoGenerator {
	constructor() {
		super('.snackbar-container', '<div class="snackbar"></div>');
	}

	generate(message, duration, {buttonMessage = '', href = '', onClick} = {}) {
		const button = $('<button></button>').html(ExtraInfoGenerator.convertMessage(buttonMessage))
			.attr('onclick', `(${onClick.toString()})()`);

		message += button.prop('outerHTML');

		super.generate(message, duration);
	}
}

// export { ToastManager, SnackbarManager };
window.ToastManager = ToastManager;
window.SnackbarManager = SnackbarManager;
